/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { ResizeEventHandler } from 'cio/components/sidebar';
import { registerDestructor, unregisterDestructor } from '@ember/destroyable';

interface ResizeHandleArgs {
  onResize: (event: ResizeEventHandler) => unknown;
}

function calculateResizeValue(event: MouseEvent) {
  return window.innerWidth - event.clientX;
}

export default class ResizeHandle extends Component<ResizeHandleArgs> {
  @action
  cleanupEventHandlers() {
    document.removeEventListener('mouseup', this.handleMouseUp);
    document.removeEventListener('mousemove', this.handleMouseMove);
  }

  @action
  handleMouseDown(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    document.addEventListener('mouseup', this.handleMouseUp);
    document.addEventListener('mousemove', this.handleMouseMove);
    registerDestructor(this, this.cleanupEventHandlers);
  }

  @action
  handleMouseUp(event: MouseEvent) {
    this.args.onResize({
      value: calculateResizeValue(event),
      isDragging: false,
    });

    this.cleanupEventHandlers();
    unregisterDestructor(this, this.cleanupEventHandlers);
  }

  @action
  handleMouseMove(event: MouseEvent) {
    // Fixes issue where mouseup is not registered if the mouse is released over an iframe
    if (event.buttons === 0) {
      return this.handleMouseUp(event);
    }

    this.args.onResize({
      value: calculateResizeValue(event),
      isDragging: true,
    });
  }
}
